"use client";

import { c as _c } from "react/compiler-runtime";
import { initAnalytics } from "@opensea/analytics";
import { ChainsProvider, MarketsProvider } from "@opensea/app-kit";
import { GraphQLProvider } from "@opensea/graphql";
import { DEFAULT_TIMEZONE } from "@opensea/i18n";
import { CurrencyProvider, PersonaProvider } from "@opensea/navigation";
import { ThemeProvider } from "@opensea/next-themes";
import { MediaContextProvider, SizeProvider, ToastProvider } from "@opensea/ui-kit";
import { captureException } from "@sentry/nextjs";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { NuqsAdapter } from "nuqs/adapters/next/app";
import { useState } from "react";
import { ItemViewModalProvider } from "@/components/items/item-page/ItemViewModal/ItemViewModalProvider";
import { OnboardingGuard } from "@/components/onboarding/OnboardingGuard";
import { ProfileSettingsProvider } from "@/components/profile/ProfileSettingsProvider";
import { IntercomProvider } from "@/components/support/IntercomProvider";
import { AccountBannedGuard } from "@/components/trustandsafety/AccountBannedGuard/AccountBannedGuard";
import { BUILD_ID } from "@/constants/env";
import { initDatadogRum } from "@/lib/integrations/datadog";
import { errorHandler as graphQLErrorHandler } from "../../lib/graphql";
import { FlagsProvider } from "../FlagsProvider";
import { IntlProvider } from "../IntlProvider";
import { RiveProvider } from "../RiveProvider";
import { WalletProvider } from "../WalletProvider";
initDatadogRum().catch(error => captureException(error));
initAnalytics({
  build: BUILD_ID
}).catch(error => {
  console.error(error);
  captureException(error);
});
export function ClientProviders(t0) {
  const $ = _c(29);
  const {
    children,
    toggles,
    persona,
    chains,
    currency,
    currencies,
    markets,
    locale,
    connectors,
    messages
  } = t0;
  const [queryClient] = useState(_temp);
  let t1;
  if ($[0] !== children) {
    t1 = <ProfileSettingsProvider><ItemViewModalProvider><AccountBannedGuard><OnboardingGuard><IntercomProvider>{children}</IntercomProvider></OnboardingGuard></AccountBannedGuard></ItemViewModalProvider></ProfileSettingsProvider>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== markets || $[3] !== t1) {
    t2 = <MarketsProvider markets={markets}>{t1}</MarketsProvider>;
    $[2] = markets;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== persona || $[6] !== t2) {
    t3 = <PersonaProvider persona={persona}>{t2}</PersonaProvider>;
    $[5] = persona;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== currency || $[9] !== t3) {
    t4 = <CurrencyProvider currency={currency}>{t3}</CurrencyProvider>;
    $[8] = currency;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== chains || $[12] !== connectors || $[13] !== currencies || $[14] !== t4) {
    t5 = <GraphQLProvider errorHandler={graphQLErrorHandler}><ToastProvider><RiveProvider><WalletProvider chains={chains} connectors={connectors} initialCurrencies={currencies}>{t4}</WalletProvider></RiveProvider></ToastProvider></GraphQLProvider>;
    $[11] = chains;
    $[12] = connectors;
    $[13] = currencies;
    $[14] = t4;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  let t6;
  if ($[16] !== queryClient || $[17] !== t5) {
    t6 = <MediaContextProvider><SizeProvider><QueryClientProvider client={queryClient}>{t5}</QueryClientProvider></SizeProvider></MediaContextProvider>;
    $[16] = queryClient;
    $[17] = t5;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  let t7;
  if ($[19] !== locale || $[20] !== messages || $[21] !== t6) {
    t7 = <ThemeProvider theme="dark"><IntlProvider locale={locale} messages={messages} timeZone={DEFAULT_TIMEZONE}>{t6}</IntlProvider></ThemeProvider>;
    $[19] = locale;
    $[20] = messages;
    $[21] = t6;
    $[22] = t7;
  } else {
    t7 = $[22];
  }
  let t8;
  if ($[23] !== t7 || $[24] !== toggles) {
    t8 = <NuqsAdapter><FlagsProvider toggles={toggles}>{t7}</FlagsProvider></NuqsAdapter>;
    $[23] = t7;
    $[24] = toggles;
    $[25] = t8;
  } else {
    t8 = $[25];
  }
  let t9;
  if ($[26] !== chains || $[27] !== t8) {
    t9 = <ChainsProvider chains={chains}>{t8}</ChainsProvider>;
    $[26] = chains;
    $[27] = t8;
    $[28] = t9;
  } else {
    t9 = $[28];
  }
  return t9;
}
function _temp() {
  return new QueryClient({});
}